import { render } from "./OpportunityReport.vue?vue&type=template&id=4bf287d6&scoped=true"
import script from "./OpportunityReport.vue?vue&type=script&lang=js"
export * from "./OpportunityReport.vue?vue&type=script&lang=js"

import "./OpportunityReport.vue?vue&type=style&index=0&id=4bf287d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf287d6"],['__file',"src/views/h5/crm/report/OpportunityReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bf287d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bf287d6', __exports__)) {
    api.reload('4bf287d6', __exports__)
  }
  
  module.hot.accept("./OpportunityReport.vue?vue&type=template&id=4bf287d6&scoped=true", () => {
    api.rerender('4bf287d6', render)
  })

}


export default __exports__